var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "emojione:flag-for-united-kingdom",
    clipPath: "url(#clip0_834_625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.1874 16.9594V13.0781L3.29053 15.2156C4.10615 15.975 5.09053 16.5656 6.1874 16.9594ZM11.8124 16.9594C12.9093 16.5656 13.8937 15.975 14.7093 15.2156L11.8124 13.05V16.9594ZM1.04053 11.8125C1.1249 12.0938 1.2374 12.3469 1.37803 12.6281L2.4749 11.8125H1.04053ZM15.5249 11.8125L16.6218 12.6281C16.7343 12.375 16.8468 12.0938 16.9593 11.8125H15.5249Z",
    fill: "#002495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.60957 10.6875H0.731445C0.81582 11.0812 0.92832 11.4469 1.04082 11.8125H2.4752L1.37832 12.6281C1.60332 13.1063 1.85645 13.5281 2.16582 13.95L5.0627 11.8125H6.1877V12.375L2.89707 14.7937L3.29082 15.1875L6.1877 13.0781V16.9594C6.55332 17.1 6.91895 17.1844 7.3127 17.2688V10.6875H6.60957ZM17.2689 10.6875H10.6877V17.2688C11.0814 17.1844 11.4471 17.0719 11.8127 16.9594V13.0781L14.7096 15.1875C15.1033 14.8219 15.4408 14.4281 15.7783 14.0062L12.7689 11.8125H14.6814L16.3971 13.0781C16.4814 12.9375 16.5658 12.7688 16.6221 12.6281L15.5252 11.8125H16.9596C17.0721 11.4469 17.1846 11.0812 17.2689 10.6875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.16553 13.95C2.39053 14.2594 2.61553 14.5406 2.86865 14.8219L6.1874 12.4031V11.8406H5.0624L2.16553 13.95ZM12.7968 11.8125L15.8062 14.0062C15.9187 13.8656 16.003 13.725 16.1155 13.5844C16.1437 13.5562 16.1437 13.5281 16.1718 13.5281C16.2562 13.3875 16.3687 13.2188 16.453 13.0781L14.6812 11.8125H12.7968Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.8124 1.04053V4.92178L14.7093 2.78428C13.8937 2.0249 12.9093 1.43428 11.8124 1.04053ZM6.1874 1.04053C5.09053 1.43428 4.10615 2.0249 3.29053 2.78428L6.1874 4.9499V1.04053ZM16.9593 6.1874C16.8749 5.90615 16.7624 5.65303 16.6218 5.37178L15.5249 6.1874H16.9593ZM2.4749 6.1874L1.37803 5.37178C1.26553 5.65303 1.15303 5.90615 1.04053 6.1874H2.4749Z",
    fill: "#002495"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.3908 7.31245H17.2408C17.1564 6.9187 17.0439 6.55308 16.9314 6.18745H15.4971L16.5939 5.37183C16.3689 4.8937 16.1158 4.47183 15.8064 4.04995L12.9377 6.18745H11.8127V5.62495L15.1033 3.2062L14.7096 2.81245L11.8127 4.92183V1.04058C11.4471 0.899951 11.0814 0.815576 10.6877 0.731201V7.31245H11.3908ZM0.731445 7.31245H7.3127V0.731201C6.91895 0.815576 6.55332 0.928076 6.1877 1.04058V4.92183L3.29082 2.81245C2.89707 3.17808 2.55957 3.57183 2.22207 3.9937L5.23145 6.18745H3.31895L1.60332 4.92183C1.51895 5.06245 1.43457 5.2312 1.37832 5.37183L2.4752 6.18745H1.04082C0.92832 6.55308 0.81582 6.9187 0.731445 7.31245Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.8346 4.0501C15.6096 3.74072 15.3846 3.45947 15.1314 3.17822L11.8127 5.59697V6.15947H12.9377L15.8346 4.0501ZM5.20332 6.1876L2.22207 3.99385C2.10957 4.13447 2.0252 4.2751 1.9127 4.41572C1.88457 4.44385 1.88457 4.47197 1.85645 4.47197C1.77207 4.6126 1.65957 4.78135 1.5752 4.92197L3.29082 6.1876H5.20332Z",
    fill: "#ED2939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M17.2688 7.3125H10.6875V0.73125C10.1531 0.61875 9.59062 0.5625 9 0.5625C8.40938 0.5625 7.84688 0.61875 7.3125 0.73125V7.3125H0.73125C0.61875 7.84688 0.5625 8.40938 0.5625 9C0.5625 9.59062 0.61875 10.1531 0.73125 10.6875H7.3125V17.2688C7.84688 17.3813 8.40938 17.4375 9 17.4375C9.59062 17.4375 10.1531 17.3813 10.6875 17.2688V10.6875H17.2688C17.3813 10.1531 17.4375 9.59062 17.4375 9C17.4375 8.40938 17.3813 7.84688 17.2688 7.3125Z",
    fill: "#ED2939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_834_625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlagIcon);
export default __webpack_public_path__ + "static/media/uk-flag-icon.c5b3411c14156335d012a6e673123581.svg";
export { ForwardRef as ReactComponent };